package com.essntl.features.service.ui.addeditservice

import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.service.domain.model.supplierservice.SupplierServiceModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.mohamedrejeb.calf.core.PlatformContext

sealed interface AddEditServiceEvent {
    data class UpdateServiceFields(val service: ServiceModel) : AddEditServiceEvent
    data class CheckRichTextChanges(val description: String) : AddEditServiceEvent
    data class GetService(val serviceId: String) : AddEditServiceEvent
    data class EditService(val description: String, val context: PlatformContext) : AddEditServiceEvent
    data class AddService(val description: String, val context: PlatformContext) : AddEditServiceEvent
    data class ToggleImageThumbnail(val index: Int) : AddEditServiceEvent
    data class AddTag(val name: String) : AddEditServiceEvent
    data class SetEditMode(val enabled: Boolean) : AddEditServiceEvent
    data class SetHasChanges(val hasChanges: Boolean) : AddEditServiceEvent
    data class AddImages(val images: List<FileModel>) : AddEditServiceEvent
    data class DeleteImage(val index: Int) : AddEditServiceEvent
    data object GetAllCategoryList : AddEditServiceEvent
    data object ClearService : AddEditServiceEvent
    data object ClearSuccessState : AddEditServiceEvent
    data object ClearImages : AddEditServiceEvent
    data class RewriteWithAI(val description: String) : AddEditServiceEvent
    data class AddSupplier(val supplier: SupplierModel) : AddEditServiceEvent
    data class RemoveSupplier(val supplierService: SupplierServiceModel) : AddEditServiceEvent
}
